<template>
  <Button class="ms-2" size="xs" color="primary" :title="$t('key_reloadbutton_title')" variant="outline" @click="click()">
    <span>
      <i class="fa-solid fa-sync" aria-hidden="true"></i>
    </span>
  </Button>
</template>

<script>

  import Button from "./../../../picko_components/generic_components/Button.vue";

  export default {
    name: "Reload",
    components: {
      Button
    },
    emits: ['change'],
    methods: {
      click() {
        this.$emit('change');
      }
    }
  };

</script>
